import { InjectedIntlProps, injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { TablePublished as TablePublishedComponent } from './TablePublished.component';

interface IOwnProps {
  collection: any;
  onPaginate: (q: any) => void;
  defaultItemPerPage?: number;
}
export type IComponentProps = InjectedIntlProps & IOwnProps;

const connector = compose<IComponentProps, IOwnProps>(injectIntl);
export const TablePublished = connector(TablePublishedComponent);
